import { HelpSection } from "app/components/HelpDrawer/HelpSection";
import { RbacChip } from "app/components/rbac/RbacChip";
import { ROLES } from "app/constants/rbac";

export const GROUP_HELP_CONTENT = (
  <HelpSection title="Roles & Targets">
    {Object.entries(ROLES).map(([role, { description }]) => (
      <div className="flex flex-col gap-y-xs" key={role}>
        <RbacChip label={role} variant="role" />
        <p>{description.long}</p>
      </div>
    ))}
  </HelpSection>
);
